import { AxiosError } from 'axios';

/**
 * Extrai mensagem legível de um erro de API (Axios) ou genérico.
 * Prioriza a mensagem retornada pelo backend (error.message),
 * depois o statusText e por último uma mensagem genérica.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as
      | { error?: { message?: string }; message?: string }
      | undefined;

    if (data?.error?.message) return data.error.message;
    if (data?.message) return data.message;
    if (error.response?.statusText) return error.response.statusText;
    if (error.message) return error.message;
  }

  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;

  return 'Ocorreu um erro inesperado. Tente novamente.';
}
